<template>
 <div>
  <el-dialog  :center="true" :close-on-click-modal="false" title="学生基本信息" :visible="showEdit" width="60%" @close="closeEditDialog">
    <el-form ref="order" :model="order" label-width="100px" :disabled="isDetail">
      <el-form-item label="学生姓名" style="width: 100%;">
        <el-input clearable v-model="order.studentName" placeholder="请输入学生姓名" style="width: 100%" :disabled="typeCustomerFunding !== '定金'"></el-input>
      </el-form-item>
      <el-form-item label="年级" style="width: 100%;">
        <el-cascader clearable style="width: 100%;" v-model="order.grade" :options="order.gradeList" :disabled="typeCustomerFunding !== '定金'"
          :props="props"></el-cascader>
      </el-form-item>
      <el-form-item label="性别">
        <el-radio-group v-model="order.sex" :disabled="typeCustomerFunding !== '定金'">
          <el-radio label="1">男</el-radio>
          <el-radio label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="学生状态">
            <el-select class="select" filterable  clearable v-model="order.state" placeholder="请选择" style="width:100%;" :disabled="typeCustomerFunding !== '定金'">
              <el-option v-for="item in classTypes_s" :key="item.value" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
      </el-form-item>
        <el-form-item label="所在地域:">
            <el-select v-model="order.regionName" clearable filterable placeholder="请选择所在地域" style="width:100%;" :disabled="typeCustomerFunding !== '定金'">
              <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
              :value="item.dictType"></el-option>
            </el-select>
        </el-form-item>
      <el-form-item label="家庭住址" style="width: 100%;">
        <el-input v-model="order.address" clearable placeholder="请输入家庭住址" style="width: 100%" :disabled="typeCustomerFunding !== '定金'"></el-input>
      </el-form-item>
      <el-form-item label="家长电话" style="width: 100%;">
        <el-input clearable v-model="order.parentPhoneNumber" @input="phoneChange" placeholder="请输入家长电话" :disabled="typeCustomerFunding !== '定金'"
          style="width: 100%"></el-input>
      </el-form-item>
      <el-form-item label="课程类别">
        <el-cascader clearable style="width: 100%;" v-model="order.courseCategoryIds" :options="categoryList" :disabled="typeCustomerFunding !== '定金'"
          :props="propsCategory"></el-cascader>
      </el-form-item>
      <el-form-item label="学生类型">
        <el-select v-model="order.classType" style="width:100%;" placeholder="请选择学生类型" filterable :disabled="typeCustomerFunding !== '定金'" >
          <el-option v-for="item in classTypsArr" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="线上诊断教师">
        <el-select multiple filterable   v-model="order.teacherIdOnlineArr" clearable style="width: 100%;" placeholder="请选择诊断老师" :disabled="typeCustomerFunding !== '定金'">
          <el-option v-for="item in teachers" :key="item.id" :label="item.realname" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="线上诊断时间" id="time">
        <el-date-picker v-model="order.onTime" type="date" style="width: 30%;" value-format="yyyy-MM-dd" :disabled="typeCustomerFunding !== '定金'"
          placeholder="请选择诊断日期" clearable>
        </el-date-picker>
        <mz-time-select style="width: 30%; display:inline-block" :childPlaceholder="'开始时间'" :timePeriod="'start1'" :class="typeCustomerFunding !== '定金' ? 'add' :  ''"
          @startTimeSelect="startTimeSelect" v-model="order.startTimeHour"
          :valueTime="order.startTimeHour"></mz-time-select>
        <span style="margin-left:5px"></span>
        <mz-time-select @clean="clean" style="width: 30%;display:inline-block" :childPlaceholder="'结束时间'" :class="typeCustomerFunding !== '定金' ? 'add' :  ''"
          :timePeriod="'end1'" @startTimeSelect="startTimeSelect" v-model="order.onEndTime"
          :valueTime="order.onEndTime"></mz-time-select>
        <el-checkbox v-model="checked" :disabled="typeCustomerFunding !== '定金'">是否线上预约</el-checkbox>
      </el-form-item>
      <el-form-item label="线下诊断教师">
        <el-select multiple v-model="order.teacherIdOfflineArr" filterable   clearable style="width: 100%;" placeholder="请选择诊断老师" :disabled="typeCustomerFunding !== '定金'">
          <el-option v-for="item in teachers" :key="item.id" :label="item.realname" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="线下诊断时间" id="time" style="margin-bottom: 0;">
        <el-date-picker style="width: 30%;" v-model="order.offTime" type="date" value-format="yyyy-MM-dd" :disabled="typeCustomerFunding !== '定金'"
          placeholder="请选择诊断日期" clearable>
        </el-date-picker>
        <mz-time-select @clean="clean" style="width: 30%; display:inline-block" :childPlaceholder="'开始时间'" :class="typeCustomerFunding !== '定金' ? 'add' :  ''"
          :timePeriod="'start'" @startTimeSelect="startTimeSelect" v-model="order.OffTimeHour"
          :valueTime="order.OffTimeHour"></mz-time-select>
        <span style="margin-left:5px"></span>
        <mz-time-select @clean="clean" style="width: 30%;display:inline-block" :childPlaceholder="'结束时间'" :class="typeCustomerFunding !== '定金' ? 'add' :  ''"
          :timePeriod="'end'" @startTimeSelect="startTimeSelect" v-model="order.offEndTime"
          :valueTime="order.offEndTime"></mz-time-select>
        <el-checkbox v-model="checked1" :disabled="typeCustomerFunding !== '定金'">是否线下预约</el-checkbox>
      </el-form-item>
      <el-form-item label="备注" style="margin-top: 20px;" >
        <el-input :rows="2" type="textarea" placeholder="请输入诊断备注" v-model="order.remarks" :disabled="typeCustomerFunding !== '定金'">
        </el-input>
      </el-form-item>


      <el-divider content-position="center">付款信息</el-divider>




      <div v-if="typeCustomerFunding === '定金'">


        <el-form-item label="学生类型">
          <el-select  v-model="isClassType" filterable   clearable style="width: 100%;" placeholder="请选择学生类型" @change="changeCustomerFunding" size="small">
            <el-option v-for="item in teacherss" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item  v-if="isClassType == 1" label="付款金额：">
          <el-input clearable v-model="paymentAmount" autocomplete="off" size="small" placeholder="请输入付款金额"></el-input>
        </el-form-item>
        <el-form-item  v-if="isClassType == 1" label="付款时间：">
          <el-date-picker v-model="paymentAmountTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" clearable placeholder="选择付款时间"></el-date-picker>
        </el-form-item>
        <el-form-item  v-if="isClassType == 1" label="付款渠道：">
          <el-select  filterable clearable  v-model="paymentAmountChannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择付款渠道">
            <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  v-if="isClassType == 1" label="诊断课：">
          <el-input clearable v-model="paymentAmountCourse" autocomplete="off" size="small" placeholder="请输入诊断课"></el-input>
        </el-form-item>


        <el-form-item  v-if="isClassType == 2" label="付款金额：">
          <el-input clearable v-model="paymentAmount" autocomplete="off" size="small" placeholder="请输入付款金额"></el-input>
        </el-form-item>
        <el-form-item  v-if="isClassType == 2" label="付款时间：">
          <el-date-picker v-model="paymentAmountTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" clearable placeholder="选择付款时间"></el-date-picker>
        </el-form-item>
        <el-form-item  v-if="isClassType == 2" label="付款渠道：">
          <el-select  filterable clearable  v-model="paymentAmountChannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择付款渠道">
            <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  v-if="isClassType == 2" label="学业课：">
          <el-input clearable v-model="paymentAmountCourse" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
        </el-form-item>


        <el-form-item label="订单状态">
          <div>
            <el-select  v-model="OrderStatus" filterable  clearable style="width: 100%;" placeholder="请选择订单状态" @change="changeOrderStatus" size="small">
              <el-option v-for="item in optionOrderStatus" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
        </el-form-item>

      </div>






      <div v-if="typeCustomerFunding === '成单'">


        <el-form-item label="学生类型">
          <el-select  v-model="isClassType" filterable disabled  clearable style="width: 100%;" placeholder="请选择学生类型" @change="changeCustomerFunding" size="small">
            <el-option v-for="item in teacherss" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否收费" v-if="isClassType === 1">
          <el-select  v-model="isThereACharge" filterable  clearable style="width: 100%;" placeholder="请选择是否收费" @change="changeisThereACharge" size="small">
            <el-option v-for="item in isThereAChargeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="规划费：" style="margin-left: 80px;">
          <el-input clearable v-model="Plan" autocomplete="off" size="small" placeholder="请输入规划费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="学业费：" style="margin-left: 80px;">
          <el-input clearable v-model="AcademicExpenses" autocomplete="off" size="small" placeholder="请输入学业费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="学业课：" style="margin-left: 80px;">
          <el-input clearable v-model="AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="家庭教育费：" style="margin-left: 80px;">
          <el-input clearable v-model="FamilyEducationExpenses" autocomplete="off" size="small" placeholder="请输入家庭教育费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="家庭教育课：" style="margin-left: 80px;">
          <el-input clearable v-model="FamilyEducationClass" autocomplete="off" size="small" placeholder="请输入家庭教育课"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="伴读费：" style="margin-left: 80px;">
          <el-input clearable v-model="AccompanyingReadingFee" autocomplete="off" size="small" placeholder="请输入伴读费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="伴读：" style="margin-left: 80px;">
          <el-input clearable v-model="AccompanyingReading" autocomplete="off" size="small" placeholder="伴读"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="付款时间：" style="margin-left: 80px;">
          <el-date-picker v-model="PaymentTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" clearable placeholder="选择付款时间"></el-date-picker>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="付款渠道：" style="margin-left: 80px;">
          <el-select  filterable clearable  v-model="Paymentchannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择付款渠道">
            <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="是否续费" v-if="isClassType === 1">
          <el-select  v-model="isYouWantToRenew" filterable  clearable style="width: 100%;" placeholder="请选择是否续费" @change="changeisYouWantToRenew" size="small">
            <el-option v-for="item in isYouWantToRenewList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item  v-if="isYouWantToRenew === 1 && isClassType === 1">
          <el-button size="small" icon="el-icon-circle-plus-outline" @click="addInput1"></el-button>
          <el-button size="small" icon="el-icon-remove-outline" @click="removeItem1"></el-button>
        </el-form-item>

        <el-form-item v-if="isYouWantToRenew === 1 && isClassType === 1">
          <el-form-item v-for="(item, index) in renewalCollectionList" :key="index" :label="'第' + (index + 1) + '期'" style="margin-left: -60px;">
              <el-input clearable v-model="item.AcademicExpenses" autocomplete="off" size="small" placeholder="请输入学业费"></el-input>
              <el-input clearable v-model="item.AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
              <el-input clearable v-model="item.FamilyEducationExpenses" autocomplete="off" size="small" placeholder="请输入家庭教育费"></el-input>
              <el-input clearable v-model="item.FamilyEducationClass" autocomplete="off" size="small" placeholder="请输入家庭教育课"></el-input>
              <el-input clearable v-model="item.AccompanyingReadingFee" autocomplete="off" size="small" placeholder="请输入伴读费"></el-input>
              <el-input clearable v-model="item.AccompanyingReading" autocomplete="off" size="small" placeholder="伴读"></el-input>
              <el-date-picker v-model="item.PaymentTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" clearable placeholder="选择付款时间"></el-date-picker>
              <el-select  filterable clearable  v-model="item.Paymentchannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择付款渠道">
                <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
          </el-form-item>
        </el-form-item>



        <el-form-item label="是否收费" v-if="isClassType === 2">
          <el-select  v-model="isThereACharge" filterable  clearable style="width: 100%;" placeholder="请选择是否收费" @change="changeisThereACharge" size="small">
            <el-option v-for="item in isThereAChargeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item  v-if="isThereACharge === 1 && isClassType === 2" label="学业费：" style="margin-left: 80px;">
          <el-input clearable v-model="AcademicExpenses" autocomplete="off" size="small" placeholder="请输入学业费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 2" label="学业课：" style="margin-left: 80px;">
          <el-input clearable v-model="AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 2" label="付款时间：" style="margin-left: 80px;">
          <el-date-picker v-model="PaymentTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" clearable placeholder="选择付款时间"></el-date-picker>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 2" label="付款渠道：" style="margin-left: 80px;">
          <el-select  filterable clearable  v-model="Paymentchannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择付款渠道">
            <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>



        <el-form-item label="是否续费" v-if="isClassType === 2">
          <el-select  v-model="isYouWantToRenew" filterable  clearable style="width: 100%;" placeholder="请选择是否续费" @change="changeisYouWantToRenew" size="small">
            <el-option v-for="item in isYouWantToRenewList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item  v-if="isYouWantToRenew === 1 && isClassType === 2">
          <el-button size="small" icon="el-icon-circle-plus-outline" @click="addInput1"></el-button>
          <el-button size="small" icon="el-icon-remove-outline" @click="removeItem1"></el-button>
        </el-form-item>

        <el-form-item v-if="isYouWantToRenew === 1 && isClassType === 2">
          <el-form-item v-for="(item, index) in renewalCollectionList" :key="index" :label="'第' + (index + 1) + '期'" style="margin-left: -60px;">
              <el-input clearable v-model="item.AcademicExpenses" autocomplete="off" size="small" placeholder="请输入学业费"></el-input>
              <el-input clearable v-model="item.AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
              <el-date-picker v-model="item.PaymentTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" clearable placeholder="选择付款时间"></el-date-picker>
              <el-select  filterable clearable  v-model="item.Paymentchannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择付款渠道">
                <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
          </el-form-item>
        </el-form-item>


        <el-form-item label="是否退费">
          <el-select  v-model="isThereARefund" filterable  clearable style="width: 100%;" placeholder="请选择是否退费"  size="small">
            <el-option v-for="item in isThereARefundList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="是否关单" v-if="isThereACharge === 2">
          <el-select  v-model="isCustomsDeclaration" filterable  clearable style="width: 100%;" placeholder="请选择是否关单" @change="changeisThereARefund" size="small">
            <el-option v-for="item in isThereARefundListt" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注原因" v-if="isCustomsDeclaration === 1 && isThereACharge === 2">
            <el-input v-model="isCustomsDeclarationchengRemarks" :autosize="{ minRows: 6, maxRows: 6 }" type="textarea"  placeholder="请输入备注原因" maxlength="300" show-word-limit></el-input>
        </el-form-item>


        <el-form-item style="" label="审批人">
          <el-select v-model="ApprovalPeople" size="small" style="width: 100%;" placeholder="请选择审批人" >
              <el-option v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="备注">
            <el-input v-model="chengRemarks" :autosize="{ minRows: 6, maxRows: 6 }" type="textarea"  placeholder="请输入备注" maxlength="300" show-word-limit></el-input>
        </el-form-item>

      </div>









      <div v-if="typeCustomerFunding === '退费'">


        <el-form-item label="客资状态">
           <div>{{ isCustomerStatus === 1 ? '定金客资' : '成单客资' }}</div>
        </el-form-item>


        <el-form-item label="学生类型">
          <el-select  v-model="isClassType" filterable  disabled clearable style="width: 100%;" placeholder="请选择学生类型" @change="changeCustomerFunding">
            <el-option v-for="item in teacherss" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item  v-if="isCustomerStatus === 1 && isClassType === 1" label="退费金额：" style="margin-left: 80px;">
          <el-input clearable v-model="AcademicExpenses" autocomplete="off" size="small" placeholder="请输入退费金额"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 1 && isClassType === 1" label="退费时间：" style="margin-left: 80px;">
          <el-date-picker v-model="PaymentTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" clearable placeholder="选择退费时间"></el-date-picker>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 1 && isClassType === 1" label="退费渠道：" style="margin-left: 80px;">
          <el-select  filterable clearable  v-model="Paymentchannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择退费渠道">
                <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 1 && isClassType === 1" label="诊断课：" style="margin-left: 80px;">
          <el-input clearable v-model="AcademicClasses" autocomplete="off" size="small" placeholder="请输入诊断课"></el-input>
        </el-form-item>



        <el-form-item  v-if="isCustomerStatus === 1 && isClassType === 2" label="退费金额：" style="margin-left: 80px;">
          <el-input clearable v-model="AcademicExpenses" autocomplete="off" size="small" placeholder="请输入退费金额"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 1 && isClassType === 2" label="退费时间：" style="margin-left: 80px;">
          <el-date-picker v-model="PaymentTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" clearable placeholder="选择退费时间"></el-date-picker>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 1 && isClassType === 2" label="退费渠道：" style="margin-left: 80px;">
          <el-select  filterable clearable  v-model="Paymentchannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择退费渠道">
                <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 1 && isClassType === 2" label="学业课：" style="margin-left: 80px;">
          <el-input clearable v-model="AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
        </el-form-item>




        <el-form-item  v-if="isCustomerStatus === 2 && isClassType === 1" label="规划费：" style="margin-left: 80px;">
          <el-input clearable v-model="Plan" autocomplete="off" size="small" placeholder="请输入规划费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2 && isClassType === 1" label="学业费：" style="margin-left: 80px;">
          <el-input clearable v-model="AcademicExpenses" autocomplete="off" size="small" placeholder="请输入学业费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2 && isClassType === 1" label="学业课：" style="margin-left: 80px;">
          <el-input clearable v-model="AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2 && isClassType === 1" label="家庭教育费：" style="margin-left: 80px;">
          <el-input clearable v-model="FamilyEducationExpenses" autocomplete="off" size="small" placeholder="请输入家庭教育费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2 && isClassType === 1" label="家庭教育课：" style="margin-left: 80px;">
          <el-input clearable v-model="FamilyEducationClass" autocomplete="off" size="small" placeholder="请输入家庭教育课"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2 && isClassType === 1" label="伴读费：" style="margin-left: 80px;">
          <el-input clearable v-model="AccompanyingReadingFee" autocomplete="off" size="small" placeholder="请输入伴读费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2 && isClassType === 1" label="伴读：" style="margin-left: 80px;">
          <el-input clearable v-model="AccompanyingReading" autocomplete="off" size="small" placeholder="伴读"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2 && isClassType === 1" label="退费时间：" style="margin-left: 80px;">
          <el-date-picker v-model="PaymentTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" clearable placeholder="选择退费时间"></el-date-picker>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2 && isClassType === 1" label="退费渠道：" style="margin-left: 80px;">
          <el-select  filterable clearable  v-model="Paymentchannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择退费渠道">
                <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item  v-if="isCustomerStatus === 2 && isClassType === 2" label="学业费：" style="margin-left: 80px;">
          <el-input clearable v-model="AcademicExpenses" autocomplete="off" size="small" placeholder="请输入学业费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2 && isClassType === 2" label="学业课：" style="margin-left: 80px;">
          <el-input clearable v-model="AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2 && isClassType === 2" label="退费时间：" style="margin-left: 80px;">
          <el-date-picker v-model="PaymentTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" clearable placeholder="选择退费时间"></el-date-picker>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2 && isClassType === 2" label="退费渠道：" style="margin-left: 80px;">
          <el-select  filterable clearable  v-model="Paymentchannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择退费渠道">
                <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>



        <el-form-item label="是否继续上课">
          <el-select  v-model="isWantToContinueTheClass" filterable  clearable style="width: 100%;" placeholder="请选择是否继续上课" @change="changeisWantToContinueTheClass">
            <el-option v-for="item in isThereARefundList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item style="" label="审批人">
          <el-select v-model="ApprovalPeople" size="small" style="width: 100%;" placeholder="请选择审批人">
              <el-option v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="备注">
            <el-input v-model="chengRemarks" :autosize="{ minRows: 6, maxRows: 6 }" type="textarea"  placeholder="请输入备注" maxlength="300" show-word-limit></el-input>
        </el-form-item>


      </div>



    </el-form>


    <div class="dialog-footer" style="text-align: end;padding-top: 30px;">
       <div style="text-align: end;">
         <el-button size="small" @click="closeEditDialog">取 消</el-button>
         <el-button size="small" type="primary" @click="saveEditForm"  v-if="!isDetail">确 定</el-button>
       </div>
    </div>

  </el-dialog>




  <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" title="原因"  :visible="isOrderStatus" :before-close="closeisOrderStatus" width="50%">
          <el-input v-model="isOrderStatusTextarea"
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 8 }"
          show-word-limit
          maxlength="9999999"
          placeholder="请输入原因"></el-input>
          <div class="dialog-footer" style="text-align: end;padding-top: 30px;">
            <div style="text-align: end;">
              <el-button size="small" @click="isOrderStatus = false, isOrderStatusTextarea = ''">取 消</el-button>
              <el-button size="small" type="primary" @click="isOrderStatus = false">确 定</el-button>
            </div>
          </div>
  </el-dialog>




 </div>
</template>



<script>
  import axios from "axios";
  import apiBaseUrl from "../../config/api";
  export default {
    props: {
      typeCustomerFunding:{
        default: "",
        type: String,
      },
      isUrView:{
        default: "",
        type: String,
      },
    },
    data() {
      return{

        isCustomerStatus: '',

        teacherss: [{id:1,name:'规划'},{id:2,name:'纯补课'}],


        optionOrderStatus: [{id:0,name:'待成单'},{id:1,name:'已成单'},{id:2,name:'未成单'},{id:3,name:'已退费'}],

        isOrderStatus: false,


        paymentAmount: '',
        paymentAmountTime: '',
        paymentAmountChannel: '',
        paymentAmountCourse: '',


        isClassType: '',


        optionsListt:[
          {dictValue:"北京", dictType:1 },
          {dictValue:"深圳", dictType:2 },
          {dictValue:"深圳", dictType:3 },
        ],

        OrderStatus: 0,

        chengRemarks:'',
        ApprovalPeople: 63,
        optionList2:[],

        classTypes_s: [{ value: 1, label: '在读' }, { value: 2, label: '结业' }, { value: 3, label: '停课' },{ value: 4, label: '流失' }],
        checked: false,
        checked1: false,
        expireTimeOption: {
          disabledDate (date) {
            //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
            return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
          }
        },
        // time: '6:00',//钟表时间
        categoryList: [], //课程集合
        orderType: [
          {
            value: 1,
            label: '已成单'
          }, {
            value: 2,
            label: '已关单'
          },
          {
            value: 3,
            label: '已退费'
          },
        ],
        props: {
          label: "gradeName",
          children: "children",
          value: "id"
        },
        propsCategory: {
          label: "categoryName",
          children: "children",
          value: "id"
        },
        payTypes: [
          {
            value: 1,
            label: "现金"
          },
          {
            value: 2,
            label: "微信"
          },
          {
            value: 3,
            label: "支付宝"
          },
          {
            value: 4,
            label: "银行卡"
          },
          {
            value: 5,
            label: "公户"
          },
          {
            value: 6,
            label: "小鹅通"
          },
          {
            value: 7,
            label: "美团"
          },
          {
            value: 8,
            label: "公户（桑穆）"
          },
          {
            value: 9,
            label: "公户（博川）"
          },
          {
            value: 10,
            label: "公户（蒙正心理）"
          }
        ], // 付款渠道选项
        customer: {},



        customerId: '',
        order: {
          classHour: "",
          familyHour: "",
          state:"",
          classType: '',
          isRenew: "2",//是否续费
          orderStatus: "",//成单状态
          remarks: "", //备注
          parentPhoneNumber: "", //家长电话
          offTeacher: "",
          OffTimeHour: "", //线下诊断时间小时
          startTimeDay: "", //诊断时间天数
          startTimeHour: "", //诊断时间小时段
          payAlltype: "",
          gradeList: [], //年级
          teacherId: "", //诊断老师id
          startTime: [], //授课时间
          payType: "", //全款付款方式
          type: "", //成交状态
          onTime: "",
          offTime: "",
          onEndTime: "", //线上结束时间
          offEndTime: "", //线下结束时间
          onlineStatus: "", //如果线上checked为true他就不为空
          offlineStatus: "", //如果线下checked为true他就不为空
          onlineTime: [], //线上诊断时间
          teacherIdOffline: "", //线下诊断教师
          teacherIdOfflineArr: [],
          teacherIdOnline: "", //线上诊断教师
          teacherIdOnlineArr: [],
          offlineTime: [], //线下诊断时间
          isDiagnosisAllPay: "", //是否交诊断费
          Lastselected: '',//取消
          diagnosisAllPayMoney: "", //诊断费用
          diagnosisTime: "", //诊断费用付款时间
          diagnosisPayType: "", //诊断费用付款方式
          allPayMoney: "", //全款费用
          payTime: "", //交全款时间
          isAllPay: "", //是否是全额尾款，分期尾款
          studentName: "", //学生姓名
          grade: [], //年级id
          sex: "", // 性别
          address: "", //家庭地址
          regionName:'',
          studentId: "", //学生ID
          courseCategoryIds: [], //课程id
          customerInformationId: "", //客资id
          renews: [
            {
              renewType: "",//续费方式
              renewTime: "",//续费时间
              renewMoney: "",//续费金额
              classHourRenew: "",
              familyHourRenew: "",
            }
          ],
          stages: [
            {
              stagesMoney: "", // 分期金额
              stagesDate: "", // 分期时间
              payType: "", // 付款渠道
              agingClassHour: "",
              agingFamilyHour: ""
            }
          ]
        },
        classTypsArr: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],
        showEdit: false,
        rules: {
            studentName: [
              {
                required: true,
                message: "请输入学生名称",
                trigger: "blur"
              }
            ],
            grade: [
              {
                required: true,
                message: "请选择年级",
                trigger: "change"
              }
            ],
            sex: [{ required: true, message: "请选择性别", trigger: "change" }],
            address: [
              {
                required: true,
                message: "请输入家庭住址",
                trigger: "blur"
              }
            ],
            parentPhoneNumber: [
              {
                required: true,
                message: "请输入家长电话",
                trigger: "blur"
              },
              { type: "number", message: "家长电话必须为数字值" }
            ],
            courseCategoryIds: [
              { required: true, message: "请选择课程类别", trigger: "change" }
            ],
            teacherId: [
              { required: true, message: "请选择授课教师", trigger: "change" }
            ],
            startTime: [
              { required: true, message: "请选择授课时间", trigger: "change" }
            ]
          },


          isOrderStatusTextarea:'',

          teachers: [
            {
              value: 1,
              label: "小单老师",
            },
            {
              value: 2,
              label: "大单老师",
            },
            {
              value: 3,
              label: "刘老师",
            },
            {
              value: 4,
              label: "杨老师",
            },
          ],


          isThereAChargeList: [{id:1,name:'是'},{id:2,name:'否'}],
          isThereACharge:'',
          isThereACharge1:'',



          Plan:'',
          AcademicExpenses:'',
          AcademicClasses:'',
          FamilyEducationExpenses:'',
          FamilyEducationClass:'',
          AccompanyingReadingFee:'',
          AccompanyingReading:'',
          PaymentTime:'',
          Paymentchannel:'',



          isYouWantToRenewList: [{id:1,name:'是'},{id:2,name:'否'}],
          isYouWantToRenew:'',




          renewalCollectionList:[
            {
              AcademicExpenses:'',
              AcademicClasses:'',
              FamilyEducationExpenses:'',
              FamilyEducationClass:'',
              AccompanyingReadingFee:'',
              AccompanyingReading:'',
              PaymentTime:'',
              Paymentchannel:'',
            }
          ],





          isThereARefundList: [{id:1,name:'是'},{id:2,name:'否'}],
          isThereARefund:'',


          isWantToContinueTheClass:'',


          isDetail: false,

          isThereARefundListt: [{id:1,name:'是'},{id:2,name:'否'}],  
          isCustomsDeclarationchengRemarks: '',
          isCustomsDeclaration: 2,

      }
    },


    mounted () {
      this.getGrade();
      this.getTeachers();
      this.getCategoryList();
      

      this.payTypes = JSON.parse(sessionStorage.getItem('payTypesList'))

      axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
        this.optionsListt = res.data.data
      })

      axios.get(`${apiBaseUrl}/orderCustomerAudit/findAuditList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
        this.optionList2 = res.data.data
      })



      // .clock-picker__input-container{
      //   background: #f3f3f3 !important;
      // }




    },


    methods: {

      changeisWantToContinueTheClass (val) {
          console.log(val, '(changeisWantToContinueTheClass)')
      },

      changeisThereACharge (val) {
          console.log(val, '(changeisThereACharge)')
      },

      changeisThereACharge1 (val) {
          console.log(val, '(changeisThereACharge1)')
      },

      changeisThereARefund (val) {
          console.log(val, '(changeisThereARefund)')
          if(val === 2){
            this.isCustomsDeclarationchengRemarks = ''
          }
      },

      changeisYouWantToRenew (val) {
          console.log(val, '(changeisYouWantToRenew)')
      },

      closeisOrderStatus(val) {
        this.isOrderStatusTextarea = ''
        this.isOrderStatus = false
      },

      changeCustomerFunding (val) {

      },

      changeOrderStatus (val) {
          if(val === 2){
             this.isOrderStatus = true
          }else{
            this.isOrderStatus = false
          }
      },


      addInput1 () {
        this.renewalCollectionList.push({
          AcademicExpenses:'',
          AcademicClasses:'',
          FamilyEducationExpenses:'',
          FamilyEducationClass:'',
          AccompanyingReadingFee:'',
          AccompanyingReading:'',
          PaymentTime:'',
          Paymentchannel:'',
        })
      },
      removeItem1 () {
        if (this.renewalCollectionList.length > 1) {
            this.renewalCollectionList.pop()
        } else {
            this.renewalCollectionList.splice(0, this.renewalCollectionList.length)
        }
      },

      startTimeSelect (val, row) {

        if (val == "start") {
          this.order.OffTimeHour = row
        } else if (val == "end") {
          this.order.offEndTime = row
        } else if (val == "start1") {
          this.order.startTimeHour = row
        } else {
          this.order.onEndTime = row
        }

      },

      endTimeSelect (val) {
        this.order.offEndTime = val
      },

      init (customerId,type) {
          this.customerId = customerId
          this.isDetail = type === 2 ? true : false
          this.showEdit = true
          axios.get(`${apiBaseUrl}/customerinformation/getOne/${customerId}`,{headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
              if (res.data.code === 200) {

                  //  this.isClassType = 1
                  //  this.isCustomerStatus = 2

                  this.isClassType = res.data.data.list.classType
                  this.isCustomerStatus = res.data.data.list.returnPremiumType

                  this.chengRemarks = res.data.data.list.commitRemark
                  this.ApprovalPeople = res.data.data.list.auditId



                  // =========================================================(定金)=======================================================
                  this.OrderStatus = res.data.data.list.orderStatus
                  this.paymentAmount = res.data.data.list.customerPaymoney
                  this.paymentAmountTime = res.data.data.list.customerPaytime
                  this.paymentAmountChannel = res.data.data.list.payType
                  this.paymentAmountCourse = res.data.data.list.customerHour
                  this.isOrderStatusTextarea = res.data.data.list.notCustomerRemark




                  // =========================================================(成单)=======================================================
                  // (1) 是否收费
                  this.isThereACharge = res.data.data.list.customerIsallpay
                  this.Plan = res.data.data.list.projectMoney
                  this.AcademicExpenses = res.data.data.list.allPayMoney
                  this.AcademicClasses = res.data.data.list.classHour
                  this.FamilyEducationExpenses = res.data.data.list.familyMoney
                  this.FamilyEducationClass = res.data.data.list.familyHour
                  this.AccompanyingReadingFee = res.data.data.list.readingPartnerMoney
                  this.AccompanyingReading = res.data.data.list.readingPartnerHour
                  this.PaymentTime = res.data.data.list.customerAllpaytime
                  this.Paymentchannel = res.data.data.list.payAlltype


                  this.isCustomsDeclaration = res.data.data.list.isClose ? res.data.data.list.isClose : 2
                  this.isCustomsDeclarationchengRemarks = res.data.data.list.closeCause ? res.data.data.list.closeCause : ''


                  // (2) 是否续费
                  this.isYouWantToRenew = res.data.data.list.isRenew

                  let renewalCollectionList = res.data.data.list.renew ? JSON.parse(res.data.data.list.renew) : []
                  let newRenewalCollectionList = []
                  renewalCollectionList.map((itme)=>{
                     let newObj = {
                        AcademicExpenses : itme.renewMoney,
                        AcademicClasses : itme.classHourRenew,
                        FamilyEducationExpenses : itme.familyMoney,
                        FamilyEducationClass : itme.familyHourRenew,
                        AccompanyingReadingFee : itme.readingPartnerMoney,
                        AccompanyingReading : itme.readingPartnerHour,
                        PaymentTime : itme.renewTime,
                        Paymentchannel : itme.renewType,
                     }

                     newRenewalCollectionList.push(newObj)
                  })

                  this.renewalCollectionList = newRenewalCollectionList


                  // (3) 是否退费
                  // this.isThereARefund = res.data.data.list.isReturnPremium
                  this.isThereARefund = res.data.data.list.isReturnPremium === 0 ? '' : res.data.data.list.isReturnPremium



                  // =========================================================(退费)=======================================================
                  this.isWantToContinueTheClass = res.data.data.list.isContinueType




                  if(res.data.data.list.returnPremium){

                      res.data.data.list.returnPremium = JSON.parse(res.data.data.list.returnPremium)

                      this.AcademicExpenses = res.data.data.list.returnPremium.returnPremiumPrice
                      this.PaymentTime = res.data.data.list.returnPremium.returnPremiumDate
                      this.Paymentchannel = res.data.data.list.returnPremium.returnPremiumPayType
                      this.AcademicClasses = res.data.data.list.returnPremium.returnPremiumHour


                      this.Plan = res.data.data.list.returnPremium.projectMoney
                      this.FamilyEducationExpenses = res.data.data.list.returnPremium.familyMoney
                      this.FamilyEducationClass = res.data.data.list.returnPremium.familyHourRenew
                      this.AccompanyingReadingFee = res.data.data.list.returnPremium.readingPartnerMoney
                      this.AccompanyingReading = res.data.data.list.returnPremium.readingPartnerHour


                  }else{
                      this.AcademicExpenses = ''
                      this.PaymentTime = ''
                      this.Paymentchannel = ''
                      this.AcademicClasses = ''
                      this.Plan = ''
                      this.FamilyEducationExpenses = ''
                      this.FamilyEducationClass = ''
                      this.AccompanyingReadingFee = ''
                      this.AccompanyingReading = ''
                  }



                 // =================================================================================================



                  this.order.studentId = res.data.data.list.studentId;
                  this.order.isRenew = res.data.data.list.isRenew + ''
                  if (res.data.data.list.renew != null) {
                    this.order.renews = JSON.parse(res.data.data.list.renew)
                  }
                  this.order.state = res.data.data.list.state
                  this.order.classHour = res.data.data.list.classHour ? res.data.data.list.classHour : ""
                  this.order.familyHour = res.data.data.list.familyHour ? res.data.data.list.familyHour : ""
                  this.order.classType = res.data.data.list.classType
                  this.order.remarks = res.data.data.list.remarks;
                  this.order.parentPhoneNumber = res.data.data.list.parentPhoneNumber;
                  this.order.customerInformationId = res.data.data.list.customerId;
                  this.order.studentName = res.data.data.list.customerStudent;
                  this.order.payType = res.data.data.list.payType;
                  this.order.sex = res.data.data.list.sex;
                  this.order.grade = res.data.data.list.gradeIdArr2;
                  this.order.courseCategoryIds = res.data.data.list.categoryIdArr2;
                  this.order.address = res.data.data.list.address;
                  this.order.regionName = Number(res.data.data.list.regionName);
                  this.order.teacherIdOnline = res.data.data.list.teacherIdOnline;
                  this.order.teacherIdOffline = res.data.data.list.teacherIdOffline;

                  // 线上诊断
                  if (res.data.data.list.teacherIdOnline == null && res.data.data.list.teacherIdOnlineArr == null) {
                    this.order.teacherIdOnlineArr = []
                  } else {
                    if (res.data.data.list.teacherIdOnlineArr == []) {
                      this.order.teacherIdOnlineArr = []
                    } else {
                      if (res.data.data.list.teacherIdOnlineArr) {
                        this.order.teacherIdOnlineArr = JSON.parse(res.data.data.list.teacherIdOnlineArr)
                      } else {
                        this.order.teacherIdOnlineArr = [res.data.data.list.teacherIdOnline]
                      }
                    }
                  }
                  // 线下诊断
                  if (res.data.data.list.teacherIdOffline == null && res.data.data.list.teacherIdOfflineArr == null) {
                      this.order.teacherIdOfflineArr = []
                  } else {
                    if (res.data.data.list.teacherIdOfflineArr == []) {
                        this.order.teacherIdOfflineArr = []
                    } else {
                      if (res.data.data.list.teacherIdOfflineArr) {
                          this.order.teacherIdOfflineArr = JSON.parse(res.data.data.list.teacherIdOfflineArr)
                      } else {
                          this.order.teacherIdOfflineArr = [res.data.data.list.teacherIdOffline]
                      }
                    }
                  }

                  this.order.teacherIdOnline = null;
                  this.order.teacherIdOffline = null;
                  this.order.startTime = JSON.parse(res.data.data.list.onlineTime);
                  this.order.orderStatus = res.data.data.list.orderStatus
                  this.order.isDiagnosisAllPay = res.data.data.list.customerIspay + "";
                  this.order.diagnosisTime = res.data.data.list.customerPaytime;

                  this.order.diagnosisAllPayMoney =
                    res.data.data.list.customerPaymoney;
                  if (res.data.data.list.onlineTime !== null) {
                    this.order.onTime = JSON.parse(res.data.data.list.onlineTime)[0];
                    this.order.startTimeHour = JSON.parse(
                      res.data.data.list.onlineTime
                    )[1];
                    this.order.onEndTime = JSON.parse(
                      res.data.data.list.onlineTime
                    )[2];
                  }
                  if (res.data.data.list.offlineTime !== null) {
                    this.order.offTime = JSON.parse(
                      res.data.data.list.offlineTime
                    )[0];
                    this.order.OffTimeHour = JSON.parse(
                      res.data.data.list.offlineTime
                    )[1];
                    this.order.offEndTime = JSON.parse(
                      res.data.data.list.offlineTime
                    )[2];
                  }

                  this.order.onlineStatus = res.data.data.list.onlineStatus;
                  this.order.offlineStatus = res.data.data.list.offlineStatus;
                  this.order.payAlltype = res.data.data.list.payAlltype;
                  this.order.isAllPay = res.data.data.list.customerIsallpay
                  this.order.allPayMoney = res.data.data.list.customerAllpaymoney;
                  this.order.payTime = res.data.data.list.customerAllpaytime;

                  if (this.order.onlineStatus == "1") {
                    this.checked = true;
                  } else {
                    this.checked = false;
                  }
                  if (this.order.offlineStatus == "1") {
                    this.checked1 = true;
                  } else {
                    this.checked1 = false;
                  }
                  if (res.data.data.list.stages !== null) {
                    this.order.stages = JSON.parse(res.data.data.list.stages);
                  }
              } else {
                this.$message({ message: res.data.message,  type: "error"  });
              }
            })

        },

        closeEditDialog () {

          this.$emit("newModesCustomerFundingDetailEvent")


          if (this.customerId === 0) {
            this.showEdit = false;
          } else {
            this.showEdit = false;
            this.$emit("resetSuccesType", this.customer);
          }
          this.order.isDiagnosisAllPay = "";
          this.order.diagnosisAllPayMoney = "";
          this.order.diagnosisTime = "";
          this.order.diagnosisPayType = "";
          this.order.isAllPay = "";
          this.order.allPayMoney = "";
          this.order.payTime = "";
          this.order.payType = "";
          this.order.state = "";
          this.order.classHour = ""
          this.order.familyHour = ""
          this.order.renews = [{ renewMoney: "", renewTime: "",  renewType: "" , classHourRenew: "", familyHourRenew: "" }]
          this.order.stages = [{ stagesMoney: "",  stagesDate: "",  payType: "", agingClassHour: "", agingFamilyHour: "" }]
          this.$refs.order.resetFields();
          this.order.startTimeHour = ""
          this.order.onEndTime = ""
          this.order.OffTimeHour = ""
          this.order.offEndTime = ""
        },

        phoneChange() {
      this.order.parentPhoneNumber = this.order.parentPhoneNumber.replace(/[^\d]/g, "");
      if (this.order.parentPhoneNumber.length > 11) {
        this.order.parentPhoneNumber = this.order.parentPhoneNumber.substr(0, 11);
      }
      let reg = /^1[3456789]\d{9}$/;
      if (this.order.parentPhoneNumber.length >= 11 && !reg.test(this.order.parentPhoneNumber)) {
         this.$notify({
          title: '警告',
          message: '请输入正确的手机号码格式',
          type: 'warning'
        });
      }
    },
    qq () {
      console.log(this.order.isRenew);
    },


    handleinput(e){
      console.log(e)
    },
    clickitem (val) {

      if(this.order.isAllPay === val ){
         this.order.isAllPay = ''
      }else{
         this.order.isAllPay = val
      }

      if(val === 1){
          this.order.allPayMoney = ""
          this.order.payTime = ""
          this.order.payAlltype = ""
          this.order.classHour = ""
          this.order.familyHour = ""
      }
      if(val === 2){
        this.order.stages = [
          {
            stagesMoney: "", // 分期金额
            stagesDate: "", // 分期时间
            payType: "", // 付款渠道
            agingClassHour: "",
            agingFamilyHour: ""
          }
        ]
      }
    },
    clean (val) {
      if (val == "start") {
        this.diagnosisOff.startTimeHour = ''
      } else {
        this.diagnosisOff.endTimeHour = ''
      }
    },
    clearDiagnosis () {
      if (
        this.order.isDiagnosisAllPay == "2" ||
        this.order.isDiagnosisAllPay == "3"
      ) {
        this.order.diagnosisAllPayMoney = "";
        this.order.diagnosisTime = "";
        this.order.diagnosisPayType = "";
      }
    },
    //点击显示钟表
    // dianji() {
    //   this.isshow = !this.isshow;
    // },
    // dianji1() {
    //   this.isshow1 = !this.isshow1;
    // },
    //绑定课程id
    handleChange (val) {
      if (val === this.Lastselected) {
        // 取消选择
        this.isDiagnosisAllPay = '';
      }
      this.Lastselected = this.isDiagnosisAllPay;
    },
    // bingCategory() {
    //   if (this.order.diagnosisAllPayMoney == 2000) {
    //     this.order.courseCategoryId = [25, 26];
    //   }
    // },


    isFull () {
      this.order.stages = [
        {
          stagesMoney: "", // 分期金额
          stagesDate: "", // 分期时间
          payType: "", // 付款渠道
          agingClassHour: "",
          agingFamilyHour: ""
        }
      ];
    },
    isNo () {
      this.order.allPayMoney = "";
      this.order.payTime = "";
      this.order.payAlltype = "";
    },
    //添加输入框
    addInput () {
      this.order.stages.push({
        stagesMoney: "",
        stagesDate: "",
        payType: "", // 付款渠道
        agingClassHour: "",
        agingFamilyHour: ""
      });
    },
    //减少输入框
    removeItem () {
      if (this.order.stages.length > 1) {
        this.order.stages.pop();
      } else {
        this.order.stages.splice(0, this.order.stages.length);
      }
    },

    orderShow (customer) {
      this.showEdit = true;
      this.customer = customer;
      this.order.studentName = customer.customerStudent;
      this.order.type = customer.type;
      this.order.customerInformationId = customer.customerId;
      this.customerId = customer.customerId;
    },

    getGrade () {
      axios
        .get(`${apiBaseUrl}/grade/getGrade`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.data.length > 0) {
            this.order.gradeList = res.data.data;
          } else {
            this.$message({
              message: "获取年级列表失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getTeachers () {
      axios
        .get(`${apiBaseUrl}/schedule/teacherDiagnosisList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.teachers = res.data.data;
        })
        .catch(error => {
          this.$message({
            message: "获取老师列表失败",
            type: "error"
          });
        });
    },
    //获取课程类别
    getCategoryList () {
      axios
        .get(`${apiBaseUrl}/category/list`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.categoryList = res.data.data;
        })
        .catch(error => {
          this.$message({
            message: "获取课程列表失败",
            type: "error"
          });
        });
    },

    saveEditForm () {

          if (this.checked == true) {
              this.order.onlineStatus = "1";
          } else {
              this.order.onlineStatus = "2";
          }

          if (this.checked1 == true) {
              this.order.offlineStatus = "1";
          } else {
              this.order.offlineStatus = "2";
          }

      // this.$refs["order"].validate(valid => {
      //   if (valid) {
          this.order.onlineTime = [ this.order.onTime,  this.order.startTimeHour,  this.order.onEndTime  ];

          if (this.order.onlineTime.length == 0) {
              this.order.onlineTime = "";
          }

          this.order.offlineTime = [ this.order.offTime,  this.order.OffTimeHour,  this.order.offEndTime  ];

          if (this.order.offlineTime.length == 0) {
              this.order.offlineTime = "";
          }

          // if (this.order.isRenew == 2) {
          //     this.order.renews = null
          // }



          this.order.classHour = this.order.classHour ? Number(this.order.classHour) : 0
          this.order.familyHour = this.order.familyHour ? Number(this.order.familyHour) : 0


          if(this.order.stages.length > 1){
             this.order.stages.forEach((itme)=>{
               itme.agingClassHour = itme.agingClassHour ? Number(itme.agingClassHour) : 0
               itme.agingFamilyHour = itme.agingFamilyHour ? Number(itme.agingFamilyHour) : 0
             })
          }else{
            //  this.order.stages = []
          }

          if(this.order.renews.length > 1){
             this.order.renews.forEach((itme)=>{
               itme.familyHourRenew = itme.familyHourRenew ? Number(itme.familyHourRenew) : 0
               itme.classHourRenew = itme.classHourRenew ? Number(itme.classHourRenew) : 0
             })
          }else{
            //  this.order.renews = []
          }

          this.order.customerIsallpay = this.order.isAllPay

          // this.order.renews = JSON.stringify(this.order.renews)
          // this.order.stages = JSON.stringify(this.order.stages)

          this.order.auditId = this.ApprovalPeople
          this.order.commitRemark = this.chengRemarks





          let newObj = {   }


          if(this.typeCustomerFunding === '定金'){
              newObj = {
                classType: this.isClassType ? this.isClassType : '',
                diagnosisAllPayMoney: this.paymentAmount ? this.paymentAmount : '',
                diagnosisTime: this.paymentAmountTime ? this.paymentAmountTime : '',
                payType: this.paymentAmountChannel ? this.paymentAmountChannel : '',
                customerHour: this.paymentAmountCourse ? this.paymentAmountCourse : '',
                orderStatus: this.OrderStatus ? this.OrderStatus : '',
                notCustomerRemark: this.isOrderStatusTextarea ? this.isOrderStatusTextarea : '',
              }
          }


          if(this.typeCustomerFunding === '成单'){

              let newStringLsit = this.renewalCollectionList.map((itme)=>{
                 let itmes = {
                    renewMoney: itme.AcademicExpenses || '',
                    classHourRenew: itme.AcademicClasses || '',
                    familyMoney: itme.FamilyEducationExpenses || '',
                    familyHourRenew: itme.FamilyEducationClass || '',
                    readingPartnerMoney: itme.AccompanyingReadingFee || '',
                    readingPartnerHour: itme.AccompanyingReading || '',
                    renewTime: itme.PaymentTime || '',
                    renewType: itme.Paymentchannel || '',
                 }
                 return itmes
              })


              newObj = {
                classType: this.isClassType ? this.isClassType : '',

                projectMoney: this.Plan ? this.Plan  : '',
                allPayMoney: this.AcademicExpenses ? this.AcademicExpenses  : '',
                classHour: this.AcademicClasses ? this.AcademicClasses  : '',
                familyHour: this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : '',
                familyMoney: this.FamilyEducationClass ? this.FamilyEducationClass  : '',
                readingPartnerMoney: this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : '',
                readingPartnerHour: this.AccompanyingReading ? this.AccompanyingReading  : '',
                payTime: this.PaymentTime ? this.PaymentTime  : '',
                payAlltype: this.Paymentchannel ? this.Paymentchannel  : '',

                renews: newStringLsit ? JSON.stringify(newStringLsit) : '[]',

                isAllPay: this.isThereACharge ? this.isThereACharge : '',
                isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                isReturnPremium: this.isThereARefund ? this.isThereARefund : '',
                auditId: this.ApprovalPeople ? this.ApprovalPeople : '',
                commitRemark: this.chengRemarks ? this.chengRemarks : '',

                isClose: this.isCustomsDeclaration,
                closeCause: this.isCustomsDeclarationchengRemarks,
              }
          }


          if(this.typeCustomerFunding === '退费'){
              newObj = {
                classType: this.isClassType || '',
                customerReturnType: this.isWantToContinueTheClass || '',

                returnPremium: JSON.stringify({
                    projectMoney: this.Plan || '',
                    returnPremiumPrice: this.AcademicExpenses || '',
                    returnPremiumHour: this.AcademicClasses || '',
                    familyMoney: this.FamilyEducationExpenses || '',
                    familyHourRenew: this.FamilyEducationClass || '',
                    readingPartnerMoney: this.AccompanyingReadingFee || '',
                    readingPartnerHour: this.AccompanyingReading || '',
                    returnPremiumDate: this.PaymentTime || '',
                    returnPremiumPayType: this.Paymentchannel || '',
                }),

                isContinueType: this.isWantToContinueTheClass || '',
                auditId: this.ApprovalPeople || '',
                commitRemark: this.chengRemarks || '',
              }
          }


          let keys = Object.keys(newObj)
          keys.forEach((key)=>{
             if (this.order.hasOwnProperty(key)) {
                 delete this.order[key]
             }
          })
          let dateObj = Object.assign(newObj, this.order)
          let isUrView = this.isUrView


          dateObj.customerId = this.customerId

          axios.post(`${apiBaseUrl}${isUrView}`, dateObj,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {

              if (res.data.code === 200) {

                this.$message({  message: "编辑成功",  type: "success" });


                this.$emit("newModesCustomerFundingDetailEvent");

                this.$emit("refreshOrder");
                this.showEdit = false;

                this.ApprovalPeople = "";
                this.chengRemarks = "";
                this.order.auditId = "";
                this.order.commitRemark = "";

                this.order.isDiagnosisAllPay = "";
                this.order.diagnosisAllPayMoney = "";
                this.order.diagnosisTime = "";
                this.order.diagnosisPayType = "";
                this.order.isAllPay = "";
                this.order.allPayMoney = "";
                this.order.payTime = "";
                this.order.payType = "";

                this.order.startTimeHour = ""
                this.order.onEndTime = ""
                this.order.OffTimeHour = ""
                this.order.offEndTime = ""

                this.order.classHour = ""
                this.order.familyHour = ""

                this.order.renews = [{  renewMoney: "",  renewTime: "",   renewType: ""  , classHourRenew: "", familyHourRenew: "" }]

                this.order.stages = [ { stagesMoney: "",  stagesDate: "",   payType: "" , agingClassHour: "", agingFamilyHour: "" }]

                this.$refs.order.resetFields();
                // this.order.startTime.splice(0, this.order.startTime.length);
              } else {
                  this.$message({ message: res.data.msg, type: "error"  });
                  this.order.classHour = this.order.classHour ? Number(this.order.classHour) : ""
                  this.order.familyHour = this.order.familyHour ? Number(this.order.familyHour) : ""

                  if(this.order.stages.length > 1){
                    this.order.stages.forEach((itme)=>{
                      itme.agingClassHour = itme.agingClassHour ? Number(itme.agingClassHour) : ""
                      itme.agingFamilyHour = itme.agingFamilyHour ? Number(itme.agingFamilyHour) : ""
                    })
                  }

                  if(this.order.renews.length > 1){
                    this.order.renews.forEach((itme)=>{
                      itme.familyHourRenew = itme.familyHourRenew ? Number(itme.familyHourRenew) : ""
                      itme.classHourRenew = itme.classHourRenew ? Number(itme.classHourRenew) : ""
                    })
                  }
              }
            });
      //   }
      // });
      this.$emit("refresh");
    }


    },



  }



</script>



<style>

.add{
  pointer-events: none;
}

</style>



// WEBPACK FOOTER //
// src/ApprovalManagement/newModesCustomerFundingDetail.vue